import React from 'react';

const FullItinerarySkeleton = () => {
  return (
    <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-6 font-sans">
      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-4 sm:p-6 lg:p-7 space-y-4">
        
        {/* Top Controls Bar Skeleton */}
        <div className="flex items-center justify-between gap-4 pb-1 flex-wrap">
          {/* Left: Back button + Title */}
          <div className="flex items-center gap-2.5 min-w-0">
            <div className="w-7 h-7 rounded-lg bg-slate-200 animate-pulse shrink-0" />
            <div className="h-6 w-56 bg-slate-200 rounded-lg animate-pulse" />
          </div>

          {/* Right: PDF Toggle + Add Day Button */}
          <div className="flex items-center gap-5 shrink-0">
            <div className="flex items-center gap-2">
              <div className="h-3.5 w-20 bg-slate-200 rounded animate-pulse" />
              <div className="w-9 h-5 rounded-full bg-slate-200 animate-pulse" />
            </div>
            <div className="h-8 w-24 rounded-lg bg-[#067978]/20 animate-pulse" />
          </div>
        </div>

        {/* Main Table Skeleton */}
        <div className="bg-white rounded-2xl border border-slate-200/90 shadow-2xs overflow-hidden w-full">
          <div className="overflow-x-auto w-full no-scrollbar">
            <table className="w-full text-left border-collapse min-w-[860px]">
              {/* Header */}
              <thead>
                <tr className="bg-slate-50/80 border-b border-slate-200">
                  <th className="py-3 px-4 w-[18%]">
                    <div className="h-3 w-16 bg-slate-200 rounded animate-pulse" />
                  </th>
                  <th className="py-3 px-4 w-[32%]">
                    <div className="h-3 w-14 bg-slate-200 rounded animate-pulse" />
                  </th>
                  <th className="py-3 px-4 w-[18%]">
                    <div className="h-3 w-12 bg-slate-200 rounded animate-pulse" />
                  </th>
                  <th className="py-3 px-4 w-[16%]">
                    <div className="h-3 w-14 bg-slate-200 rounded animate-pulse" />
                  </th>
                  <th className="py-3 px-4 w-[16%]">
                    <div className="h-3 w-20 bg-slate-200 rounded animate-pulse" />
                  </th>
                </tr>
              </thead>

              {/* Body */}
              <tbody className="divide-y divide-slate-100">
                {[1, 2, 3].map((dayIndex) => (
                  <tr key={dayIndex} className="align-top">
                    {/* Col 1: Itinerary Day Info */}
                    <td className="py-4 px-4">
                      <div className="space-y-2">
                        <div className="h-5 w-14 rounded-md bg-[#067978]/15 animate-pulse" />
                        <div className="h-3.5 w-24 bg-slate-200 rounded animate-pulse" />
                        <div className="h-4 w-32 bg-slate-100 rounded animate-pulse" />
                        <div className="flex items-center gap-2 pt-2">
                          <div className="w-6 h-6 rounded-md bg-slate-100 animate-pulse" />
                          <div className="w-6 h-6 rounded-md bg-slate-100 animate-pulse" />
                        </div>
                      </div>
                    </td>

                    {/* Col 2: Events / Particulars */}
                    <td className="py-4 px-4">
                      <div className="space-y-3">
                        <div className="p-2.5 rounded-xl bg-slate-50/80 border border-slate-100 space-y-1.5">
                          <div className="flex items-center gap-2">
                            <div className="h-4 w-12 bg-[#067978]/15 rounded animate-pulse" />
                            <div className="h-4 w-40 bg-slate-200 rounded animate-pulse" />
                          </div>
                          <div className="h-3 w-56 bg-slate-100 rounded animate-pulse" />
                        </div>
                        <div className="p-2.5 rounded-xl bg-slate-50/80 border border-slate-100 space-y-1.5">
                          <div className="flex items-center gap-2">
                            <div className="h-4 w-12 bg-[#067978]/15 rounded animate-pulse" />
                            <div className="h-4 w-36 bg-slate-200 rounded animate-pulse" />
                          </div>
                          <div className="h-3 w-48 bg-slate-100 rounded animate-pulse" />
                        </div>
                      </div>
                    </td>

                    {/* Col 3: Driver */}
                    <td className="py-4 px-4">
                      <div className="p-3 rounded-xl bg-slate-50/70 border border-slate-100 space-y-2 animate-pulse">
                        <div className="flex items-center gap-2">
                          <div className="w-7 h-7 rounded-full bg-slate-200 shrink-0" />
                          <div className="space-y-1 flex-1">
                            <div className="h-3 w-20 bg-slate-200 rounded" />
                            <div className="h-2.5 w-16 bg-slate-100 rounded" />
                          </div>
                        </div>
                      </div>
                    </td>

                    {/* Col 4: Tickets */}
                    <td className="py-4 px-4">
                      <div className="p-3 rounded-xl bg-slate-50/70 border border-slate-100 space-y-2 animate-pulse">
                        <div className="h-3 w-24 bg-slate-200 rounded" />
                        <div className="h-2.5 w-16 bg-slate-100 rounded" />
                      </div>
                    </td>

                    {/* Col 5: Pickup & Drop */}
                    <td className="py-4 px-4">
                      <div className="p-3 rounded-xl bg-slate-50/70 border border-slate-100 space-y-2 animate-pulse">
                        <div className="h-3 w-24 bg-slate-200 rounded" />
                        <div className="h-2.5 w-20 bg-slate-100 rounded" />
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  );
};

export default FullItinerarySkeleton;
